import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBookmark = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10.2 41.7V8.85q0-1.149.864-2.011.862-.864 2.011-.864h21.85q1.148 0 2.012.864.863.862.863 2.011V41.7L24 35.8zm2.875-4.35L24 32.717l10.925 4.633V8.85h-21.85z" })
});
export default SvgBookmark;
